// src/app/theme.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private isDark = false;

  constructor() {
    // preferencia do SO
    // const prefers = window.matchMedia('(prefers-color-scheme: dark)').matches;
    // this.setDark(prefers);
  }

  setDark(enable: boolean) {
    // this.isDark = enable;
    // document.documentElement.classList.toggle('dark', enable);
  }

  toggle() {
    // this.setDark(!this.isDark);
  }

  get dark() { return this.isDark; }
}
